var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9976 0L12.8232 0.592505V17.7841L12.9976 17.9581L20.9776 13.2411L12.9976 0Z",
    fill: "#48515F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9976 0L5.0174 13.2411L12.9976 17.9581V9.61381V0Z",
    fill: "#79879C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9977 19.4689L12.8994 19.5888V25.7127L12.9977 25.9997L20.9825 14.7543L12.9977 19.4689Z",
    fill: "#48515F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9977 25.9997V19.4689L5.01746 14.7543L12.9977 25.9997Z",
    fill: "#79879C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9977 17.9581L20.9776 13.2411L12.9977 9.61377V17.9581Z",
    fill: "#657183"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01746 13.2411L12.9977 17.9581V9.61377L5.01746 13.2411Z",
    fill: "#4A5362"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthLogo);
export default __webpack_public_path__ + "static/media/ethLogo.a80efedddcf90ac7eaffd4fec27691b3.svg";
export { ForwardRef as ReactComponent };